import type { LinkProps } from '@remix-run/react';
import { Link } from '@remix-run/react';

import { useRepubContext } from '~/providers/repub-context';

import styles from './styles/AppLinks.module.css';

type AppLinkProps = LinkProps & {
  resourcesUrl: string;
  type: 'GOOGLE_PLAY' | 'APP_STORE';
};

export const AppLink = ({ resourcesUrl, type, ...props }: AppLinkProps) => {
  if (type === 'GOOGLE_PLAY') {
    return (
      <Link {...props}>
        <img alt="Get it on Google play button" src={`${resourcesUrl}/assets/img/app/GooglePlay.png`} />
      </Link>);

  }
  return (
    <Link {...props}>
      <img alt="Download on the app store button" src={`${resourcesUrl}/assets/img/app/AppStore.png`} />
    </Link>);

};

export const AppLinks = ({ resourcesUrl }: {resourcesUrl: string;}) => {
  const { repubIs } = useRepubContext();

  if (!repubIs.US) {
    return null;
  }

  return (
    <div className={styles.appLinks} data-testid="app-links">
      <AppLink
        resourcesUrl={resourcesUrl}
        to="https://apps.apple.com/us/app/oddschecker-ai-betting-tools/id6459478704"
        type="APP_STORE" />

      <AppLink
        resourcesUrl={resourcesUrl}
        to="https://play.google.com/store/apps/details?id=com.oddschecker.mapp.oddscheckerusa&hl=en_IN&gl=US"
        type="GOOGLE_PLAY" />

    </div>);

};

AppLink.displayName = 'AppLink';